<script setup lang="ts">
import { useRouter } from 'vue-router'
import { VButton } from '@/modules/shared/components'
import AuthLayout from '@/modules/auth/layouts/auth-layout.vue'

const router = useRouter()

const goBack = () => router.back()
</script>

<template>
  <AuthLayout>
    <div class="w-full sm:w-[380px]">
      <header>
        <h1 class="text-3xl leading-9 text-gray-900">Page not found</h1>
        <p class="mt-6 text-gray-700">The page you're looking for doesn't exist. Please check the URL.</p>
      </header>
      <main class="sm:mt-18 mt-12">
        <VButton variant="v-green" size="xl" @click="goBack">← back</VButton>
      </main>
    </div>
  </AuthLayout>
</template>
